module.exports = __webpack_public_path__ + "static/media/4.a5ac8363.jpg";